module.exports = __webpack_public_path__ + "static/media/plus.aba9de2d.png";